module.exports = __webpack_public_path__ + "static/pinkfloral4-c1267c43e6a2ee813c359aa92ead9f6b.png";